import Cookies from 'js-cookie'
import some from 'lodash/some'
import type { CreateMarketingData } from '@/api/kubik/monolith'
import { createMarketingEntry } from '@/api/kubik/monolith'
import { SERVER_DATE_FORMAT } from '@/constants/common'
import { formatDate } from '@/utils/formatUtils'
import { getUtmParametersFromCookies } from '@/utils/utm/getUtmParametersFromCookies'
import { getUtmParametersFromSearchString } from '@/utils/utm/getUtmParametersFromSearchString'
import { EUtmParameters } from '@/utils/utm/types'

export async function sendMarketingRequest() {
  const utmParametersFromUrl = getUtmParametersFromSearchString(window.location.search)
  const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = utmParametersFromUrl

  const hasSomeUtm = Boolean(utmCampaign || utmMedium || utmSource || utmContent || utmTerm)

  if (hasSomeUtm) {
    const utmFromCookies = getUtmParametersFromCookies()

    const isEveryUtmSame =
      utmCampaign === utmFromCookies.utmCampaign &&
      utmMedium === utmFromCookies.utmMedium &&
      utmSource === utmFromCookies.utmSource &&
      utmContent === utmFromCookies.utmContent &&
      utmTerm === utmFromCookies.utmTerm

    if (isEveryUtmSame) return
  }

  const hasUtmParams = some(utmParametersFromUrl, Boolean)

  if (!hasUtmParams) return

  const createRequestBody: CreateMarketingData = {
    entryDate: formatDate(new Date(), SERVER_DATE_FORMAT),
    ...utmParametersFromUrl,
  }

  const clientId = Cookies.get('agromarket_client_id')

  if (!clientId) return

  try {
    await createMarketingEntry(createRequestBody, { 'X-Client-Id': clientId })
  } catch (error) {
    return
  }

  Cookies.set(EUtmParameters.UTM_CAMPAIGN, utmCampaign || 'EMPTY')
  Cookies.set(EUtmParameters.UTM_MEDIUM, utmMedium || 'EMPTY')
  Cookies.set(EUtmParameters.UTM_SOURCE, utmSource || 'EMPTY')
  Cookies.set(EUtmParameters.UTM_CONTENT, utmContent || 'EMPTY')
  Cookies.set(EUtmParameters.UTM_TERM, utmTerm || 'EMPTY')
}
